import Carousel from './carousel';

class ImagesCarousel extends Carousel {
  constructor(selector: any = '.js-images-carousel', settings: object = {}) {
    const TIME = 5000;
    const SPEED = 800;

    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const pagination: HTMLElement | null | undefined = el?.querySelector('.o-editorial-image-slider__pagination');

    super(el, {
      ...settings,
      effect: window.innerWidth >= 1024 ? 'fade' : 'slide',
      fadeEffect: {
        crossFade: window.innerWidth >= 1024 ? true : false,
      },
      grabCursor: true,
      autoHeight: false,
      speed: SPEED,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: TIME,
      },
      navigation: {
        prevEl: el ? el.querySelector('.swiper-button-prev') : '.swiper-button-prev',
        nextEl: el ? el.querySelector('.swiper-button-next') : '.swiper-button-next',
      },
      centeredSlides: window.innerWidth >= 1024 ? false : true,
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: (swiper: any) => {
          pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);

          if ((window.innerWidth >= 1024 && swiper.slides.length - 1 <= 2) || (window.innerWidth < 1024 && swiper.slides.length - 1 <= 1)) {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            swiper.params.loop = false;
          }
        },
      },
    });
  }
}

export default ImagesCarousel;
